import React from 'react'
import { formatDateDDMMYYYY, formatDateHM } from './aifeatures/utils'

export interface MeetingDateProps {
  startedAt: string
  finishedAt?: string
}

export const MeetingDateAndTime: React.FC<MeetingDateProps> = ({ startedAt, finishedAt }) => {
  return (
    <div className='d-flex gap-2'>
      <i className='bi bi-calendar' />
      <div className='paragraph-medium'>
        {formatDateDDMMYYYY(startedAt)} <span className='zocks-text-gray-900 p-1'>&middot;</span> {formatDateHM(startedAt)} -{' '}
        {finishedAt ? formatDateHM(finishedAt) : ''}
      </div>
    </div>
  )
}
